// components/common/Loading/Loading.tsx
import styles from './Loading.module.css';
import DigiBrigiLogo from '../DigiBrigiLogo/DigiBrigiLogo';

interface LoadingProps {
  /** 'logo' shows the animated brand logo; anything else shows a spinner. */
  variant?: 'logo' | 'spinner';
  /** When true, fills the viewport height; otherwise sizes to content. */
  maxHeight?: boolean;
}

const Loading = ({ variant, maxHeight = true }: LoadingProps) => (
  <div className={maxHeight ? styles.loadingContainer : styles.loadingContainerDynamicHeight}>
    {variant === 'logo' ? (
      <div className={styles.brandLogo}>
        <DigiBrigiLogo size={52} />
      </div>
    ) : (
      <>
        <div className={styles.spinner} />
        <p className={styles.loadingText}>Načítání...</p>
      </>
    )}
  </div>
);

export default Loading;
